import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import PaymentMethodCard from '../PaymentMethodCard';
import SectionTitle from '../SectionTitle';

import styles from './PaymentMethodList.Styles';

function PaymentMethodList({
  cards,
  onPressMakePreferred,
  onCardPress,
  isLoading,
  makePreferredBtnStyle,
}) {
  const cardsList =
    cards && cards.length
      ? cards.map(card => {
          const { id } = card;
          return (
            <PaymentMethodCard
              key={id}
              onCardPress={() => onCardPress(id)}
              onPressMakePreferred={onPressMakePreferred}
              makePreferredBtnStyle={makePreferredBtnStyle}
              showMakePreferred={true}
              card={card}
            />
          );
        })
      : null;

  return (
    <View style={styles.otherCards}>
      <SectionTitle title="payment_other_payment_methods" />
      {isLoading ? <PaymentMethodCard isLoading /> : cardsList}
    </View>
  );
}

PaymentMethodList.propTypes = {
  isLoading: PropTypes.bool,
  onCardPress: PropTypes.func,
  cards: PropTypes.array,
  onPressMakePreferred: PropTypes.func,
  makePreferredBtnStyle: PropTypes.shape({
    parent: PropTypes.object,
    container: PropTypes.object,
    text: PropTypes.object,
  }),
};

export default PaymentMethodList;
